@switch (inputAppearance()) {
    @case ('action-button') {
        <ng-container *ngTemplateOutlet="actionButtonTemplate"></ng-container>
    }
    @default {
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
    }
}

<ng-template #actionButtonTemplate>
    <form aria-label="Site search" class="search-form" role="search" [attr.data-appearance]="inputAppearance()">
        <div class="search-form__field">
            <div class="search-form__input-container">
                <input
                    [coreAutoFocus]="autoFocus"
                    [formControl]="queryField"
                    autocomplete="off"
                    class="search-form__input form-control"
                    id="search"
                    [placeholder]="'Search' | translate"
                    tabindex="0"
                    type="text" />

                <!-- Clear search input-->
                @if (search.showClearButton && queryField.value.trim().length > 0) {
                    <button
                        (click)="resetSearch()"
                        aria-label="Clear"
                        class="search-form__clear-button btn-close btn--search-clear"
                        type="button">
                        <span aria-hidden="true" class="visually-hidden">&times;</span>
                    </button>
                }
            </div>

            <button class="search-form__submit-button">
                <core-icon name="icon-search" color="currentColor" [size]="[22, 22]"></core-icon>
            </button>
        </div>
    </form>
</ng-template>

<ng-template #defaultTemplate>
    <form aria-label="Site search" class="search-form" role="search" [attr.data-appearance]="inputAppearance()">
        <input
            [coreAutoFocus]="autoFocus"
            [formControl]="queryField"
            autocomplete="off"
            class="search-form__input form-control"
            id="search"
            [placeholder]="'Search' | translate"
            tabindex="0"
            type="text" />

        <label class="search-form__label" for="search">
            <span class="sr-only">Search</span>
            <core-icon name="icon-search" color="var(--color-text)"></core-icon>
        </label>

        <!-- Clear search input-->
        @if (search.showClearButton) {
            <button (click)="resetSearch()" aria-label="Clear" class="btn-close btn--search-clear" type="button">
                <span aria-hidden="true" class="visually-hidden">&times;</span>
            </button>
        }
    </form>
</ng-template>
